import {defineStore} from "pinia";
import {ref} from "vue";

export const useGlobalStore = defineStore('global', () => {
    const showFooter = ref(true);
    const apiAvailable = ref(true);

    return {apiAvailable, showFooter};
});
